export default __webpack_public_path__ + "static/media/3.84d24e4e.png";